import {
  BookingContainerInput,
  PhotoRequirementInput,
} from './mutationBookingCreate';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingUpdateDraftAtom = createMutationAtomFactory(
  'trade.bookingUpdateDraft',
  (params: {
    id: string;
    facilityId?: string;
    documentNumber?: string;
    cutOffDate?: string;
    earlyReturnDate?: string;
    vesselArrivalDate?: string;
    vesselDepartureDate?: string;
    vesselName?: string;
    loadingPortId?: string;
    pickupTerminalId?: string;
    destinationPortId?: string;
    dropoffTerminalId?: string;
    steamshipLine?: string;
    oceanFreight?: string;
    internalNotes?: string;
    externalNotes?: string;
    photoRequirements?: PhotoRequirementInput[];
    containers?: BookingContainerInput[];
    salesOrderIds?: string[];
  }) => ({
    tradeBookingUpdateDraft: {
      __args: {
        id: params.id,
        input: {
          facilityId: params.facilityId,
          documentNumber: params.documentNumber,
          cutOffDate: params.cutOffDate,
          earlyReturnDate: params.earlyReturnDate,
          vesselArrivalDate: params.vesselArrivalDate,
          vesselDepartureDate: params.vesselDepartureDate,
          vesselName: params.vesselName,
          loadingPortId: params.loadingPortId,
          pickupTerminalId: params.pickupTerminalId,
          destinationPortId: params.destinationPortId,
          dropoffTerminalId: params.dropoffTerminalId,
          steamshipLine: params.steamshipLine,
          oceanFreight: params.oceanFreight,
          internalNotes: params.internalNotes,
          externalNotes: params.externalNotes,
          photoRequirements: params.photoRequirements,
          containers: params.containers,
          salesOrderIds: params.salesOrderIds,
        },
      },
      id: true,
      facilityId: true,
      documentNumber: true,
      status: true,
      cutOffDate: true,
      earlyReturnDate: true,
      vesselArrivalDate: true,
      vesselDepartureDate: true,
      vesselName: true,
      loadingPortId: true,
      loadingPort: {
        id: true,
        unLocode: true,
        name: true,
        countryCode: true,
      },
      pickupTerminalId: true,
      pickupTerminal: {
        id: true,
        terminalCode: true,
        name: true,
      },
      destinationPortId: true,
      destinationPort: {
        id: true,
        unLocode: true,
        name: true,
        countryCode: true,
      },
      dropoffTerminalId: true,
      dropoffTerminal: {
        id: true,
        terminalCode: true,
        name: true,
      },
      steamshipLine: true,
      oceanFreight: true,
      internalNotes: true,
      externalNotes: true,
      containers: {
        containerType: {
          id: true,
          name: true,
        },
        quantity: true,
      },
      photoRequirements: {
        description: true,
        required: true,
      },
      salesOrders: {
        id: true,
        documentNumber: true,
        counterpartyReferenceNumber: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
